(function () {
  'use strict';

  function initPetFriendlySection(root) {
    if (!root || root.getAttribute('data-pet-friendly-initialized') === 'true') return;

    var accordionItems = Array.prototype.slice.call(root.querySelectorAll('[data-pet-item]'));
    var activeImage = root.querySelector('[data-pet-active-image]');
    var swiperEl = root.querySelector('.pet-friendly-swiper');
    var prevBtn = root.querySelector('.pet-prev');
    var nextBtn = root.querySelector('.pet-next');
    var swiperInstance = null;

    function updateDesktop(index) {
      accordionItems.forEach(function (item, itemIndex) {
        var isActive = itemIndex === index;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      var activeItem = accordionItems[index];
      if (!activeItem || !activeImage) return;

      activeImage.src = activeItem.getAttribute('data-pet-image') || '';
      activeImage.alt = activeItem.getAttribute('data-pet-title') || '';
    }

    accordionItems.forEach(function (item, index) {
      function activateItem() {
        updateDesktop(index);
      }

      item.addEventListener('click', activateItem);
      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        activateItem();
      });
    });

    if (typeof Swiper !== 'undefined' && swiperEl) {
      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        watchOverflow: true,
        allowTouchMove: false,
        simulateTouch: false,
        touchRatio: 1,
        threshold: 5,
        touchStartPreventDefault: false,
        grabCursor: false,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
          850: {
            allowTouchMove: true,
            simulateTouch: true,
            grabCursor: true,
            // slidesOffsetBefore: 28,
            // slidesOffsetAfter: 28,
          },
        },
      });
    }

    updateDesktop(0);
    root._petFriendlyDestroy = function () {
      if (swiperInstance && typeof swiperInstance.destroy === 'function') {
        swiperInstance.destroy(true, true);
      }
      root.removeAttribute('data-pet-friendly-initialized');
      root._petFriendlyDestroy = null;
    };
    root.setAttribute('data-pet-friendly-initialized', 'true');
  }

  function initAll() {
    document.querySelectorAll('[data-pet-friendly-section]').forEach(initPetFriendlySection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    event.target.querySelectorAll('[data-pet-friendly-section]').forEach(initPetFriendlySection);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;
    event.target.querySelectorAll('[data-pet-friendly-section]').forEach(function (root) {
      if (root._petFriendlyDestroy) root._petFriendlyDestroy();
    });
  });
})();
